<div class="comp-header">
  <div class="comp-header__inner">
    <h1 class="h3">Adgangsgrupper</h1>
    <div class="comp-header__actions">
      <button
        type="button"
        [admRequiresFeatureRole]="roles['shared-access-group-discount.read']"
        mat-button
        (click)="manageSharedDiscounts()">
        <mat-icon svgIcon="icon_transverse_discount"></mat-icon>
        Tværgående rabatter
      </button>
      <button
        type="button"
        [admRequiresFeatureRole]="roles['access-group.write']"
        mat-raised-button
        color="primary"
        (click)="createOrEditAccessGroup()">
        <svg class="icon-20"><use href="assets/images/ok-icons-sprite.svg#plus-s"></use></svg>
        <span>Opret adgangsgruppe</span>
      </button>
    </div>
  </div>
  <div>
    @if (state.focusedAccessGroup()) {
      @let focusedAccessGroup = state.focusedAccessGroup();
      <div class="comp-header__deeplinked">
        <svg class="icon-24"><use href="assets/images/ok-icons-sprite.svg#info-s"></use></svg>
        Listen er filtreret til adgangsgruppe &nbsp;
        <strong>{{ focusedAccessGroup?.name }}</strong>
        <button (click)="resetFilter()" class="actions__reset margin--left-m" mat-stroked-button>Nulstil</button>
      </div>
    } @else if (state.focusedConnector()) {
      @let focusedConnector = state.focusedConnector();
      <div class="comp-header__deeplinked">
        <svg class="icon-24"><use href="assets/images/ok-icons-sprite.svg#info-s"></use></svg>
        Listen er filtreret til connector &nbsp;
        <strong>{{ focusedConnector?.description }}</strong>
        <button (click)="resetFilter()" class="actions__reset margin--left-m" mat-stroked-button>Nulstil</button>
      </div>
    } @else {
      <adm-access-group-filter
        [searchText]="state.form.controls.query.value ?? ''"
        [organizationId]="state.form.controls.organizationId.value ?? null"
        [locationIdentifier]="state.form.controls.locationIdentifier.value ?? null"
        [selectedCarType]="state.form.controls.selectedCarType.value ?? null"
        [sharedDiscountIdentifier]="state.form.controls.sharedDiscountIdentifier.value ?? null"
        [resetOrgTrigger]="state.resetOrgTrigger()"
        [resetLocationTrigger]="state.resetLocationTrigger()"
        [resetDiscountTrigger]="state.resetDiscountTrigger()"
        (search$)="querySearchInput($event)"
        (organizationSelected)="organizationSelected($event ?? undefined)"
        (clearOrganizationSelector)="clearOrganizationSelector()"
        (organizationsFetched)="organizationsFetched($event)"
        (locationSelected)="locationSelected($event)"
        (discountSelected)="discountSelected($event)"
        (carTypeSelected)="selectCarType($event)"
        (resetAllFilters)="resetFilter()" />
    }
  </div>
</div>
<div class="comp-main access-groups">
  @if ((appState.isInErrorState$ | async) === false) {
    <ok-card [loading]="state.loading()">
      <ok-expand-list
        [trackBy]="'identifier'"
        [sort]="currentSort()"
        [data]="data().items"
        [configuration]="config()"
        (sortChange)="onSortChange($event)">
      </ok-expand-list>

      <mat-paginator
        #paginator
        class="paginator"
        [disabled]="state.loading()"
        [pageIndex]="state.viewState().page.pageIndex"
        [pageSize]="state.viewState().page.pageSize"
        [length]="data().totalCount || 0"
        [pageSizeOptions]="state.pagingOptions()"
        (page)="pageSwitch($event)"
        color="accent" />
    </ok-card>

    @if (data().items.length === 0 && !state.loading()) {
      <div class="no-results align-center">
        <p>Der blev ikke fundet nogen adgangsgrupper</p>
      </div>
    }
  }
</div>

<ng-template #organizationColumnTemplate let-accessGroup>
  <a class="blue ellipsis block" [routerLink]="['/organizations']" [queryParams]="{ organizationId: accessGroup.organizationId }">
    {{ accessGroup.organizationName }}
  </a>
</ng-template>

<ng-template #connectorCountColumnTemplate let-accessGroup>
  <a class="blue" [routerLink]="['/locations']" [queryParams]="{ accessGroupIdentifier: accessGroup.identifier }">
    {{ accessGroup.connectorCount }}
  </a>
</ng-template>

<ng-template #accessCountColumnTemplate let-accessGroup>
  @if (authService.hasRole(roles[Permission.AccessGroupWrite])) {
    <a class="blue pointer" (click)="editAccessGroupAccess(accessGroup)">{{ accessGroup.accessCount }}</a>
  } @else {
    {{ accessGroup.accessCount }}
  }
</ng-template>

<ng-template #carTypeColumnTemplate let-accessGroup>
  {{ accessGroup.carType | translateAccessGroupCarTypeEnum }}
</ng-template>

<ng-template #amountColumnTemplate let-accessGroup>
  <span class="discount-type-column">
    @if (accessGroup.discountType === discountType.FixedAmount) {
      {{ accessGroup.amount | dkCurrency }}
    }
    @if (accessGroup.discountType === discountType.Percentages) {
      {{ accessGroup.amount | number: '1.2-2' }} %
    }
    @if (accessGroup.sharedDiscountIdentifier) {
      <mat-icon
        svgIcon="icon_transverse_discount"
        class="shared-discount-icon"
        [matTooltip]="'Tværgående rabat: ' + accessGroup.sharedDiscountName"></mat-icon>
    }
  </span>
</ng-template>

<ng-template #createdColumnTemplate let-accessGroup>
  {{ accessGroup.created | date: 'short' }}
</ng-template>
